import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const manageProductEditApi = createApi({
    reducerPath: "manageProductEditApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    tagTypes: ["Products"],  
    endpoints: (builder) => ({
         
        updateConsigned: builder.mutation({
            query: (payload) => ({
                url: "/Product/update-consigned",
                method: "PUT",
                body: payload,
            }),
            invalidatesTags: ["Products"],
        }),
 
        updateOwned: builder.mutation({
            query: (payload) => ({
                url: "/Product/update-owned",
                method: "PUT",
                body: payload,
            }),
            invalidatesTags: ["Products"],
        }),
 
        updateOther: builder.mutation({
            query: (payload) => ({
                url: "/Product/update-other",
                method: "PUT",
                body: payload,
            }),
            invalidatesTags: ["Products"],
        }),

    }),
});

export const { 
    useUpdateConsignedMutation, 
    useUpdateOwnedMutation, 
    useUpdateOtherMutation 
} = manageProductEditApi;